import { Outlet, useLocation } from "react-router-dom";
import Header from "../components/Header";
import { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { MessagesContainer } from "../components/messages/MessagesContainer";
import Media from "../api/Media";
import { MyNotesWidget } from "../components/widgets/MyNotesWidget";
import { NoteReminderToasts } from "../components/widgets/NoteReminderToasts";
import NotesWidget from "../api/NotesWidget";

const HEADER_SIDEBAR_EXPANDED_KEY = "header_sidebar_expanded";

function readSidebarExpandedFromStorage() {
  try {
    const stored = localStorage.getItem(HEADER_SIDEBAR_EXPANDED_KEY);
    if (stored === "true") {
      return true;
    }
    if (stored === "false") {
      return false;
    }
  } catch {
    /* ignore */
  }
  return true;
}

const LayOut = observer(() => {
  const location = useLocation();

  const [visibleHeader, setVisibleHeader] = useState(() =>
    readSidebarExpandedFromStorage(),
  );

  useEffect(() => {
    if (!Media.mobile) {
      try {
        localStorage.setItem(
          HEADER_SIDEBAR_EXPANDED_KEY,
          String(visibleHeader),
        );
      } catch {
        /* ignore */
      }
    }
  }, [visibleHeader]);

  useEffect(() => {
    if (localStorage.getItem("User") != null) {
      NotesWidget.startReminderEngine();
    }
  }, []);

  // const beginLoading = async () => {
  //   if (ApiData.isAuth) {
  //     await ApiData.getDataCompanys();
  //   }
  // };

  // useEffect(() => {
  //   beginLoading();
  // }, []);

  return (
    <div
      className={!Media.mobile ? "layout-container" : "layout-container-mobile"}
    >
      {location.pathname !== "/login" ||
      localStorage.getItem("User") !== null ||
      location.pathname !== "/" ? (
        <Header
          visibleHeader={visibleHeader}
          setVisibleHeader={setVisibleHeader}
        />
      ) : (
        null
      )}

      <main
        className="container"
        style={{
          marginLeft:
            !Media.mobile && visibleHeader
              ? "300px"
              : !Media.mobile && !visibleHeader
              ? "80px"
              : "0",
        }}
      >
        <MessagesContainer />
        <NoteReminderToasts />
        <Outlet />
      </main>
      <MyNotesWidget />
    </div>
  );
});

export { LayOut };
